var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5846 0.874054C4.83464 0.874054 0.167969 5.54072 0.167969 11.2907C0.167969 17.0407 4.83464 21.7074 10.5846 21.7074C16.3346 21.7074 21.0013 17.0407 21.0013 11.2907C21.0013 5.54072 16.3346 0.874054 10.5846 0.874054ZM9.54297 6.08239V10.2491H5.3763V12.3324H9.54297V16.4991H11.6263V12.3324H15.793V10.2491H11.6263V6.08239H9.54297ZM2.2513 11.2907C2.2513 15.8845 5.99089 19.6241 10.5846 19.6241C15.1784 19.6241 18.918 15.8845 18.918 11.2907C18.918 6.69697 15.1784 2.95739 10.5846 2.95739C5.99089 2.95739 2.2513 6.69697 2.2513 11.2907Z",
    fill: "#616376"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.8d84bf7dae303cc675b52859e7c11bed.svg";
export { ForwardRef as ReactComponent };